import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import { BRAND } from '../config';
import './Sessions.css';

const Prizes = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [prizes, setPrizes] = useState([]);
  const [message, setMessage] = useState({ type: '', text: '' });

  useEffect(() => {
    loadPrizes();
  }, []);

  const loadPrizes = async () => {
    setLoading(true);
    try {
      const response = await api.get('/admin/prizes', {
        params: { brand: BRAND }
      });
      setPrizes(response.data);
    } catch (error) {
      console.error('Error loading prizes:', error);
      setMessage({ type: 'error', text: 'Erreur lors du chargement des lots' });
    } finally {
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const handleBack = () => {
    navigate('/dashboard');
  };

  if (loading) {
    return (
      <div className="sessions-container">
        <div className="loading-screen">
          <div className="spinner-border text-danger" role="status"></div>
          <p>Chargement...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="sessions-container">
      <div className="sidebar">
        <div className="sidebar-header">
          <img src="/logo.png" alt="American Cola" className="cola-logo" style={{ width: '40px', height: 'auto' }} />
          <h3>AMERICAN COLA</h3>
          <p className="sidebar-subtitle">Administration</p>
        </div>

        <nav className="sidebar-nav">
          <button className="nav-item" onClick={() => navigate('/dashboard')}>
            <i className="fas fa-arrow-left"></i>
            <span>Retour Dashboard</span>
          </button>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <i className="fas fa-user-circle"></i>
            <span>{user?.username}</span>
          </div>
          <button onClick={handleLogout} className="logout-btn">
            <i className="fas fa-sign-out-alt"></i>
            Déconnexion
          </button>
        </div>
      </div>

      <div className="main-content">
        <header className="content-header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <button className="btn-back" onClick={handleBack}>
              <i className="fas fa-arrow-left"></i>
              Retour
            </button>
            <h1>🎁 Lots</h1>
          </div>
          <p className="brand-badge">American Cola</p>
        </header>

        {message.text && (
          <div className={`alert alert-${message.type}`}>
            {message.text}
          </div>
        )}

        <div className="sessions-grid">
          {prizes.length === 0 ? (
            <div className="empty-state">
              <i className="fas fa-gift" style={{ fontSize: '64px', color: '#bf0a30', marginBottom: '20px' }}></i>
              <h3>Aucun lot</h3>
              <p>Il n'y a aucun lot configuré pour le moment.</p>
            </div>
          ) : (
            prizes.map((prize) => (
              <div key={prize.id} className="session-card">
                <div className="card-header">
                  <div className="card-icon">🎁</div>
                  <h2>{prize.name || `Lot ${prize.id}`}</h2>
                </div>
                <div className="card-body">
                  <div className="session-info">
                    <div className="info-row">
                      <span className="info-label">Type:</span>
                      <span className="info-value">{prize.type || '-'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Description:</span>
                      <span className="info-value">{prize.description || '-'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Probabilité:</span>
                      <span className="info-value">{prize.probability || 0}%</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Quota journalier:</span>
                      <span className="info-value">{prize.daily_quota || 'Illimité'}</span>
                    </div>
                    <div className="info-row">
                      <span className="info-label">Statut:</span>
                      <span className="status-badge" style={{
                        background: prize.is_active ? '#e8f5e8' : '#ffe5e5',
                        color: prize.is_active ? '#228b22' : '#bf0a30'
                      }}>
                        {prize.is_active ? 'Actif' : 'Inactif'}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default Prizes;
